import axios from 'axios';
import {
  GET_CONSTRUCTION_TYPES,
  GET_CONSTRUCTION_TYPES_SUCCESS,
  GET_CONSTRUCTION_TYPES_ERROR,
  ADD_CONSTRUCTION_TYPE,
  ADD_CONSTRUCTION_TYPE_SUCCESS,
  ADD_CONSTRUCTION_TYPE_ERROR,
  EDIT_CONSTRUCTION_TYPE,
  EDIT_CONSTRUCTION_TYPE_SUCCESS,
  EDIT_CONSTRUCTION_TYPE_ERROR,
  DELETE_CONSTRUCTION_TYPE,
  DELETE_CONSTRUCTION_TYPE_SUCCESS,
  DELETE_CONSTRUCTION_TYPE_ERROR,
} from './types';

const apiURL = `${process.env.VUE_APP_API_URL}/construction-types`;
const requestOptions = { timeout: 30000 };

const errorDetails = (error) => {
  const data = error.response && error.response.data;
  return {
    message: (data && data.message) || error.message || 'Не вдалося виконати запит.',
    fields: (data && data.errors) || {},
  };
};

export default {
  async [GET_CONSTRUCTION_TYPES]({ commit }) {
    commit(GET_CONSTRUCTION_TYPES);
    try {
      const { data } = await axios.get(apiURL, requestOptions);
      commit(GET_CONSTRUCTION_TYPES_SUCCESS, data.data);
      return data.data;
    } catch (error) {
      commit(GET_CONSTRUCTION_TYPES_ERROR, errorDetails(error));
      throw error;
    }
  },
  async [ADD_CONSTRUCTION_TYPE]({ commit }, constructionType) {
    commit(ADD_CONSTRUCTION_TYPE);
    try {
      const { data } = await axios.post(apiURL, { name: constructionType.name }, requestOptions);
      commit(ADD_CONSTRUCTION_TYPE_SUCCESS);
      return data;
    } catch (error) {
      commit(ADD_CONSTRUCTION_TYPE_ERROR, errorDetails(error));
      throw error;
    }
  },
  async [EDIT_CONSTRUCTION_TYPE]({ commit }, constructionType) {
    commit(EDIT_CONSTRUCTION_TYPE);
    try {
      const { data } = await axios.post(`${apiURL}/${constructionType.id}`, {
        _method: 'PUT',
        name: constructionType.name,
      }, requestOptions);
      commit(EDIT_CONSTRUCTION_TYPE_SUCCESS);
      return data;
    } catch (error) {
      commit(EDIT_CONSTRUCTION_TYPE_ERROR, errorDetails(error));
      throw error;
    }
  },
  async [DELETE_CONSTRUCTION_TYPE]({ commit }, id) {
    commit(DELETE_CONSTRUCTION_TYPE);
    try {
      const { data } = await axios.post(`${apiURL}/${id}`, {
        _method: 'DELETE',
      }, requestOptions);
      commit(DELETE_CONSTRUCTION_TYPE_SUCCESS);
      return data;
    } catch (error) {
      commit(DELETE_CONSTRUCTION_TYPE_ERROR, errorDetails(error));
      throw error;
    }
  },
};
